export const ROUTES = {
  analytics:
    "https://analytics.google.com/analytics/web/#/p406359049/reports/intelligenthome",
  abogueoRegister: "https://profesionales.abogueo.com/register",
  stripeCustomers: "https://dashboard.stripe.com/test/customers",
}
